// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-tree[data-v-1526349d] {\n  padding: 24px 0 24px 24px;\n  width: 100%;\n  height: 100%;\n  font-size: 12px;\n  color: #595959;\n}\n", ""]);
// Exports
module.exports = exports;
